export const madeList = [
  { value: "Aprilla", label: "Aprilla" },
  { value: "BMW", label: "BMW" },
  { value: "Ducati", label: "Ducati" },
  { value: "Harley-Davidson", label: "Harley-Davidson" },
  { value: "Honda", label: "Honda" },
  { value: "Indian", label: "Indian" },
  { value: "Kawasaki", label: "Kawasaki" },
  { value: "KTM", label: "KTM" },
  { value: "Moto Guzzi", label: "Moto Guzzi" },
  { value: "Suzuki", label: "Suzuki" },
  { value: "Triumph", label: "Triumph" },
  { value: "Victory", label: "Victory" },
  { value: "Yamaha", label: "Yamaha" },
  { value: "Other", label: "Other" },
];
